import { Envs } from '@traba/types'

import { configEnv } from '../config'

const DEV_ICON_HREFS = {
  'link[rel="icon"][type="image/svg+xml"]': '/favicon-dev.svg',
  'link[rel="icon"][type="image/png"][sizes="32x32"]': '/favicon-dev-32x32.png',
  'link[rel="icon"][type="image/png"][sizes="16x16"]': '/favicon-dev-16x16.png',
  'link[rel="apple-touch-icon"]': '/apple-touch-icon-dev.png',
  'link[rel="manifest"]': '/site-dev.webmanifest',
} as const

export function setEnvFavicon(): void {
  if (configEnv === Envs.PRODUCTION) {
    return
  }
  for (const [selector, href] of Object.entries(DEV_ICON_HREFS)) {
    const link = document.querySelector<HTMLLinkElement>(selector)
    if (link) {
      link.href = href
    }
  }
}
